var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main-content',[(_vm.$can('update', 'user'))?_c('kt-panel',[_c('kt-panel-body',[(_vm.is_data_ready)?_c('update-form',{attrs:{"on_submit":_vm.update,"form_data":_vm.form_data,"form_meta_data":_vm.form_meta_data}}):_vm._e()],1)],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }